import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { renderField } from "../utilities/functions";
import { AiOutlineProfile } from "react-icons/ai";



export default function CreateBeneficiarySP({ show, showFn }) {
    const [fullInfo, setFullInfo] = useState();

    useEffect(() => { setFullInfo(false); }, []);
    const navigate = useNavigate();


    const addServiceProvider = () => {
       let spid = "00000000-0000-0000-0000-000000000000";
        if (fullInfo) navigate('/AddBeneficiaryProfile/' + spid, {state : {previousPage:"/serviceProviders"}})
            else navigate('/AddServiceProviderProfile/' + spid, {state : {previousPage:"/serviceProviders"}})
        showFn(false);
    }

    const cancelFn = () => {
        showFn(false)
    }

    const handleInputChange = (e) => {
        setFullInfo(e.target.checked);
    }

    return show === true ?
        <div id="beneSPModal" className="fixed flex z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full">
            <div class="flex-1 p-4 w-full max-w-md h-full md:h-auto">
                <div class=" p-4 text-center rounded-lg sm:p-5" className="form-container">
                    <h1 className="py-2 form-label">
                        <AiOutlineProfile className="inline-icon" />
                        Create Service Provider/Beneficiary
                    </h1>

                    {renderField("Create a Beneficiary.", "fullInfo", "checkbox", fullInfo, handleInputChange)}

                    <span class="py-2 text-sm ">{fullInfo === true ? "Beneficiary needs full Sensitive Data View of Shared Information (Beneficiary can not issue documents)" : "This is a Service provider"} </span>
                    <div class="flex justify-center items-center space-x-4 py-2 ">
                        <button onClick={addServiceProvider} type="submit" className="button-style positive-action">
                            Create
                        </button>
                        <button onClick={cancelFn} type="button" className="button-style">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
        : <></>
}